module.exports = __webpack_public_path__ + "static/img/index1.50f833f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/vibrate/BY_S07/index1.png
// module id = 3Q5M
// module chunks = 0